import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AthleteService } from '../../../../providers/athlete/athlete.service';
import { AuthService } from '../../../../providers/auth.provider';

@Component({
  selector: 'ngx-athlete-resumen-dialog',
  templateUrl: 'athlete-resumen-dialog.component.html',
  styleUrls: ['athlete-resumen-dialog.component.scss'],
})
export class AthleteResumenDialogComponent {

  @Input() data: any;
  isLoadingProfileImg: boolean = false;
  isLoadingDocumentImg: boolean = false;
  isLoadingBirthCertImg: boolean = false;
  isLoading: boolean = false;
  profileImg = null;
  defaultProfileImg = "assets/img/no-photo.png";
  documentImg = null;
  documentImgViewerOpen = false;
  birthCertImg = null;
  birthCertImgViewerOpen = false;
  defaultImg = "assets/img/not-found.png";

  public sportSelected = null;
  public sports = [];


  incompleteMessage = "Incomplete Data";
  constructor(protected ref: NbDialogRef<AthleteResumenDialogComponent>, private athleteService: AthleteService, private authService: AuthService) { }
  public isCoach = false;

  ngOnInit(): void {
    this.loadProfilePic();
    this.loadIdDocumentPic();
    this.loadBirthCertPic();
    this.isCoach = this.authService.getUserInfo().coach; 
    this.isLoading = true;
    this.loadData();

    this.sports = this.data.sports;
    if(this.sports && this.sports.length) {
      this.sportSelected = this.sports[0];
    }

  }

  onChangeTabSport() {

  }

  onClose() {
    this.ref.close();
  }

  loadData() {
    this.athleteService.findAthlete(this.data.id)
      .finally(() => this.isLoading = false)
      .then(resAthlete => {
        this.data = resAthlete;
      })
  }

  loadProfilePic() {
    this.isLoadingProfileImg = true;
    this.athleteService.getProfilePic(this.data.id)
      .then((imgFile: any) => {
        if (imgFile) {
          var reader = new FileReader();
          reader.readAsDataURL(imgFile);
          reader.onloadend = (event: ProgressEvent) => {
            this.profileImg = reader.result;
            this.isLoadingProfileImg = false;
          }
        } else {
          this.profileImg = null;
          this.isLoadingProfileImg = false;
        }
      }).catch(() => {
        this.isLoadingProfileImg = false;
      });
  }

  loadIdDocumentPic() {
    this.isLoadingDocumentImg = true;
    this.authService.getIdentificationDocumentPic(this.data.id)
      .then((imgFile: any) => {
        if (imgFile) {
          var reader = new FileReader();
          reader.readAsDataURL(imgFile);
          reader.onloadend = (event: ProgressEvent) => {
            this.documentImg = reader.result;
            this.isLoadingDocumentImg = false;
          }
        } else {
          this.documentImg = null;
          this.isLoadingDocumentImg = false;
        }
      }).catch(() => {
        this.isLoadingDocumentImg = false;
      });
  }

  loadBirthCertPic() {
    this.isLoadingBirthCertImg = true;
    this.athleteService.getBirthCertPic(this.data.id)
      .then((imgFile: any) => {
        if (imgFile) {
          var reader = new FileReader();
          reader.readAsDataURL(imgFile);
          reader.onloadend = (event: ProgressEvent) => {
            this.birthCertImg = reader.result;
            this.isLoadingBirthCertImg = false;
          }
        } else {
          this.birthCertImg = null;
          this.isLoadingBirthCertImg = false;
        }
      }).catch(() => {
        this.isLoadingBirthCertImg = false;
      });
  }

}
